import axiosHandler from '../axiosInterceptors';
import { FETCH_DEVICE_DATA, CREATE_DEVICE_DATA, UPDATE_DEVICE_DATA, DELETE_DEVICE_DATA, FETCH_DEVICE_GLOBAL_SEARCH_DATA,UPLOAD_BULK_DEVICE_DATA, DEACTIVATE_DEVICE_LIST, FETCH_MAC_PID_DEVICE } from '../constants/urls';
import setAuthHeader from './AuthHeader';
// Call the setAuthHeader function to set the Authorization header
setAuthHeader();

export async function fetchDeviceData(filterType) {
    try{
        const resp = await axiosHandler.get(FETCH_DEVICE_DATA+ `?filterType=${filterType}`);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function createDeviceData(data) {
    try{
        const resp = await axiosHandler.post(CREATE_DEVICE_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data;
    }
}

export async function updateDeviceData(data) {
    try{
        const resp = await axiosHandler.patch(UPDATE_DEVICE_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteDeviceData(data) {
    try{
        const resp = await axiosHandler.delete(DELETE_DEVICE_DATA + `?id=${data.id}`);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchDeviceGlobalSearchData(data, filterType) {
    try{
        const resp = await axiosHandler.post(FETCH_DEVICE_GLOBAL_SEARCH_DATA+ `?filterType=${filterType}`, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function uploadBulkDevice(fileData){
    try{
        const resp = await axiosHandler.post(UPLOAD_BULK_DEVICE_DATA, fileData);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deactivateDevice(data) {
    try{
        const resp = await axiosHandler.patch(DEACTIVATE_DEVICE_LIST, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function fetchMacListfromDeviceViaPid(data) {
    try{
        const resp = await axiosHandler.post(FETCH_MAC_PID_DEVICE, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    } 
}